export * from './promotion-item';
